import { getUser, updateProfile, updateProfilePassword } from '@/api/user';
import { getCachedItem, cacheItem, forgetItem } from '../cache';

const userKey = 'user';

const state = () => ({
	user: getCachedItem(userKey) || null,
});

const getters = {
	user: state => state.user,
	// Set on the signed in user by the API. Editors reach the admin panel like
	// administrators do, but none of the CRM menu is theirs.
	isAdmin: state => state.user?.is_admin === true,
};

const actions = {
	getUser({ commit }) {
		return getUser().then(user => {
			commit('setUser', user);
		});
	},
	// The signed in user edits themselves here. The admin user resource is CRM, so
	// an editor is refused it even for their own row.
	updateProfile({ commit }, payload) {
		return updateProfile(payload).then(response => {
			commit('setUser', response.data);
			return response;
		});
	},
	// Asks for the password in place, unlike the admin one, which overwrites it.
	updateProfilePassword(_, payload) {
		return updateProfilePassword(payload);
	},
};

const mutations = {
	setUser(state, user) {
		state.user = user;
		cacheItem(userKey, user);
	},
	clearUser(state) {
		state.user = null;
		forgetItem(userKey);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
